import React, {Component} from 'react';
import PropTypes from 'prop-types';

import './Shaker.css';

// must match value from Shaker.css
const animation_duration = 0.8;

export default class Shaker extends Component {
	constructor(props) {
		super(props);
		this.delay = Math.random() * -1 * animation_duration + 's';
	}
	render() {
		const {shaking, children} = this.props;
		return <div 
			className={shaking ? 'Shaker' : ''}
			style={{
	      animationDelay: this.delay,
			}}
		>
			{children}
		</div>
	}
}
Shaker.propTypes = {
	shaking: PropTypes.bool,
};
Shaker.defaultProps = {
	shaking: false,
};

// function to wrap another component and add "shaking" prop
export function Shakeable(Component) {
	function render({shaking, ...rest}) {
		return <Shaker shaking={shaking}><Component {...rest}/></Shaker>
	}
	return render;
}


// WEBPACK FOOTER //
// ./src/Shaker.js